type IOrganizationField =
  | 'companyName'
  | 'companyWebsite'
  | 'companyRegistrationNumber'
  | 'country'
  | 'streetNumber'
  | 'postalCode'
  | 'region'
  | 'city'
  | 'street';

const keyToLabel: Record<IOrganizationField, string> = {
  companyName: 'Organization name updated',
  companyWebsite: 'Website updated',
  companyRegistrationNumber: 'Registration number updated',
  street: 'Street address updated',
  streetNumber: 'Number / Suite / Unit / Floor updated',
  city: 'City updated',
  region: 'State / Province / Region updated',
  country: 'Country updated',
  postalCode: 'Zip / Postal code updated',
};

const formatChangeMessage = (key: string, value: string): { label: string; value: string } => {
  return {
    label: keyToLabel[key as keyof typeof keyToLabel],
    value: value === '' ? '-' : value,
  };
};

export const getOrganizationSuggestedChangesItems = (organization: Partial<Record<IOrganizationField, unknown>>) => {
  return Object.entries(organization).map(([key, newValue]) => formatChangeMessage(key, newValue as string));
};
